

import './Button.css';

import Link from '../../ui/Link/Link';

export const AddButton = (props) => {
    return <div className={`button add`} style={props.style} onClick={props.callback}><div className='icon add'/></div>
}

export const CloseButton = (props) => {
    return <div className={`button close ${typeof props.className !== 'undefined' ? props.className : ''}`} style={props.style} onClick={props.callback}><div className='icon close'/></div>
}

export const EditButton = (props) => {
    return <div className={`button edit`} style={props.style} onClick={props.callback}><div className='icon edit long-arrow-right'/></div>
}

export const BackButton = (props) => {
    return <Link className={`button edit`} style={props.style} href={props.href}><div className='icon edit long-arrow-right'/></Link>
}